import { Type, type Static } from "@sinclair/typebox";

export const AGENT_TURN_LIMITS = {
  maxCurrentMessageChars: 20_000,
  maxHistoryMessages: 20,
  maxHistoryMessageChars: 20_000,
  maxHistoryChars: 40_000,
  maxBackgroundMessages: 5,
  maxBackgroundMessageChars: 4_000,
  maxBackgroundChars: 10_000,
  maxBackgroundFileNames: 16,
  maxBackgroundFileNameChars: 512
} as const;

export const AgentTurnMessageSchema = Type.Object(
  {
    role: Type.Union([Type.Literal("user"), Type.Literal("assistant")]),
    content: Type.String({ minLength: 1, maxLength: AGENT_TURN_LIMITS.maxHistoryMessageChars })
  },
  { additionalProperties: false }
);

export const AgentTurnBackgroundMessageSchema = Type.Object(
  {
    content: Type.String({
      minLength: 1,
      maxLength: AGENT_TURN_LIMITS.maxBackgroundMessageChars
    }),
    fileNames: Type.Optional(
      Type.Array(
        Type.String({ minLength: 1, maxLength: AGENT_TURN_LIMITS.maxBackgroundFileNameChars }),
        { maxItems: AGENT_TURN_LIMITS.maxBackgroundFileNames }
      )
    )
  },
  { additionalProperties: false }
);

export const AgentTurnInputSchema = Type.Object(
  {
    currentMessage: Type.String({
      minLength: 1,
      maxLength: AGENT_TURN_LIMITS.maxCurrentMessageChars
    }),
    history: Type.Array(AgentTurnMessageSchema, {
      maxItems: AGENT_TURN_LIMITS.maxHistoryMessages
    }),
    background: Type.Optional(
      Type.Array(AgentTurnBackgroundMessageSchema, {
        maxItems: AGENT_TURN_LIMITS.maxBackgroundMessages
      })
    )
  },
  { additionalProperties: false }
);

export type AgentTurnMessage = Static<typeof AgentTurnMessageSchema>;
export type AgentTurnBackgroundMessage = Static<typeof AgentTurnBackgroundMessageSchema>;
export type AgentTurnInput = Static<typeof AgentTurnInputSchema>;
